import React from 'react'
import styled from 'styled-components'
import {BodyText} from './text.js'
import Link from './link.js'

const UnstyledSubItem = ({
  className,
  entry
}) => {
  const title = entry.title

  const props = {
    className 
  }

  return (
    <div {...props}>
      <Link {...entry}>
        <Title>{title}</Title>
      </Link>
    </div>
  )
}

const SubItem = styled(UnstyledSubItem)`

`


const Title = styled(BodyText)`
  text-align: center;
`

export default SubItem